module.exports = __webpack_public_path__ + "img/logo_perfcell.e34c76c3.png";